var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_528",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134.6 134.6",
    style: {
      enableBackground: "new 0 0 134.6 134.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3F1F1;}\n\t.st1{fill:#50AEEB;}\n\t.st2{fill:#273C49;}\n\t.st3{fill:#329F2C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    className: "st0",
    d: "M132,34.2v92.6c0,2.9-2.4,5.3-5.3,5.3c0,0,0,0,0,0H7.9c-2.9,0-5.3-2.4-5.3-5.3c0,0,0,0,0,0V34.2 H132z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    className: "st1",
    d: "M126.8,13.1c2.9,0,5.3,2.4,5.3,5.3c0,0,0,0,0,0v15.8H2.6V18.4c0-2.9,2.4-5.3,5.3-5.3 c0,0,0,0,0,0H126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    className: "st2",
    d: "M126.8,10.5h-9.3c0-5.8-4.7-10.5-10.5-10.5c-5.7,0-10.4,4.6-10.4,10.3c0,0.1,0,0.2,0,0.3H78 C78,4.7,73.3,0,67.5,0c-5.7,0-10.4,4.6-10.4,10.3c0,0.1,0,0.2,0,0.3H38.5C38.5,4.7,33.8,0,28,0c-5.7,0-10.4,4.6-10.4,10.3 c0,0.1,0,0.2,0,0.3H7.9c-4.4,0-7.9,3.5-7.9,7.9v108.3c0,4.4,3.5,7.9,7.9,7.9h118.9c4.4,0,7.9-3.5,7.9-7.9V18.4 C134.6,14.1,131.1,10.5,126.8,10.5z M101.8,10.4c-0.1-2.8,2.2-5.1,5-5.2c0.1,0,0.1,0,0.2,0c2.9,0,5.3,2.4,5.3,5.3L101.8,10.4 C101.8,10.5,101.8,10.5,101.8,10.4L101.8,10.4z M62.3,10.4c-0.1-2.8,2.2-5.1,5-5.2c0.1,0,0.1,0,0.2,0c2.9,0,5.3,2.4,5.3,5.3 L62.3,10.4C62.3,10.5,62.3,10.5,62.3,10.4L62.3,10.4z M22.9,10.4c-0.1-2.8,2.2-5.1,5-5.2c0.1,0,0.1,0,0.2,0c2.9,0,5.3,2.4,5.3,5.3 L22.9,10.4C22.9,10.5,22.9,10.5,22.9,10.4L22.9,10.4z M126.8,129.4H7.9c-1.5,0-2.6-1.2-2.6-2.6V36.8h67.7c1.5,0,2.6-1.2,2.6-2.6 c0-1.5-1.2-2.6-2.6-2.6H5.3V18.4c0-1.5,1.2-2.6,2.6-2.6h9.7v7.9c0,1.5,1.2,2.6,2.6,2.6c1.5,0,2.6-1.2,2.6-2.6c0,0,0,0,0,0v-7.9 h34.2v7.9c0,1.5,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6l0,0v-7.9h34.2v7.9c0,1.5,1.2,2.6,2.6,2.6c1.5,0,2.6-1.2,2.6-2.6l0,0v-7.9h25 c1.5,0,2.6,1.2,2.6,2.6v13.1H66.3c-1.5,0-2.6,1.2-2.6,2.6c0,1.5,1.2,2.6,2.6,2.6h63.1v89.9C129.4,128.2,128.2,129.4,126.8,129.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    transform: "translate(19.025 62.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    transform: "translate(3.359 0.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    className: "st2",
    d: "M87.9,3.9H2c-1.1,0-2-0.9-2-2s0.9-2,2-2l0,0h85.9c1.1,0,2,0.9,2,2S89,3.9,87.9,3.9L87.9,3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    transform: "translate(3.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    className: "st2",
    d: "M2,16c-1.1,0-2-0.9-2-2l0,0V2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2l0,0v12C3.9,15.1,3.1,16,2,16 C2,16,2,16,2,16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    transform: "translate(89.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    className: "st2",
    d: "M2,16c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2s2,0.9,2,2v12C3.9,15.1,3.1,16,2,16C2,16,2,16,2,16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    transform: "translate(46.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    className: "st2",
    d: "M2,16c-1.1,0-2-0.9-2-2l0,0V2c0-1.1,0.9-2,2-2s2,0.9,2,2v12C3.9,15.1,3.1,16,2,16 C2,16,2,16,2,16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    transform: "translate(0 22.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    className: "st2",
    cx: 5.3,
    cy: 5.3,
    r: 5.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    transform: "translate(42.968 22.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    className: "st2",
    cx: 5.3,
    cy: 5.3,
    r: 5.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    transform: "translate(85.936 22.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    className: "st3",
    cx: 5.3,
    cy: 5.3,
    r: 5.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepThree);
export default __webpack_public_path__ + "static/media/step-three.b580faf7713de301e79dc38b1689fe3f.svg";
export { ForwardRef as ReactComponent };